import type { InputType } from 'config'

/**
 * Fields a vendor record can legitimately arrive without.
 *
 * Both are classification rather than payment detail: a Vendor Type is a tenant's own list, and an
 * EIN is reporting information. Neither is needed to pay anybody.
 */
export const OPTIONAL_WHEN_UNSET = ['type', 'ein']

/**
 * Stop a field a record never carried from blocking an edit to that record.
 *
 * Every vendor a conversion loads arrives with no Vendor Type, and the company's own payee record,
 * which is opened automatically the first time the company is paid rather than keyed in, has
 * neither that nor an EIN. Both are required fields on the form, so saving such a record failed
 * validation on information nobody was being asked to change, and the edit that actually matters on
 * one of them could not be made: adding the bank details that let the payee be paid by ACH instead
 * of by check.
 *
 * Relaxed only where the value is genuinely absent, so nothing already on file can be emptied by
 * saving, and adding a vendor by hand still asks for both.
 */
export const relaxUnsetOptionalFields = (inputs: Record<string, InputType>) => {
  OPTIONAL_WHEN_UNSET.forEach((key) => {
    if (inputs[key] && !inputs[key].value) inputs[key].required = false
  })
  return inputs
}
